import PropTypes from 'prop-types';
import { Colors } from 'components/styles/Theme';

export default PropTypes.oneOf(Object.keys(Colors));
